---
title: About Programming
description: プログラミングスキル及びその他のこと
cover_image: "/images/article/fatos-bytyqi-Agx5_TLsIf4-unsplash.jpg"
---

かれこれ20年以上やってるけど、自信なんてものはない。  
自信はないが、これまでなんとかやってこれている。  

### 業務経験のある言語

- JavaScript, Java, Python, C#, Ruby, PHP, その他諸々

### 業務経験はないけどほんのり程度触れる言語
（または習得を目指して勉強中である言語）

- Rust, Erlang, Elixir

### 経歴的ななにか
##### 90年代後半〜00年代中旬
- N88BASICでプログラミング入門
- 高校時代にVB, C, Z80アセンブリ, PICマイコンなどの電子工作やポケコンなどで遊ぶ
- 工業系大学の工学部時代にC++, Java, PHP等々で遊ぶ

##### 〜10年代初頭
- SIer時代にVB6, VB.NET, C#, ASP.NET, MSSQL, Oracle(PL/SQL)あたりの技術スタックを得る
  + （独立を視野に入れつつ上記以外の新しい技術を身につけるべく奮闘してた時代）

##### 10年代中旬〜後半
- 個人事業として独立、フリーランスとしてWeb技術全般を身に付ける
  + フロントエンドエンジニアを名乗ることもあるけど、正直やりたいことが実現できるならフロントだけにこだわるつもりもないです。

##### 20年代〜現在
- 猫になりたい



<br>
<br>
<br>

----
<small><span>Photo by <a href="https://unsplash.com/@fatosi?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Fatos Bytyqi</a> on <a href="https://unsplash.com/s/photos/programming?utm_source=unsplash&amp;utm_medium=referral&amp;utm_content=creditCopyText">Unsplash</a></span></small>